import { render, staticRenderFns } from "./modelFour.vue?vue&type=template&id=070977f4&scoped=true&"
import script from "./modelFour.vue?vue&type=script&lang=js&"
export * from "./modelFour.vue?vue&type=script&lang=js&"
import style0 from "./modelFour.vue?vue&type=style&index=0&id=070977f4&lang=scss&scoped=true&"
import style1 from "./modelFour.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070977f4",
  null
  
)

export default component.exports